<template>
  <div
    :class="{ preview: isPreview }"
    :data-card-seq="seq"
    :data-card-nm="name"
    :data-promotion-seq="promotionSeq"
    :data-it-seq="itSeq"
    :data-destination-type="destinationType"
    :data-destination-url="destinationUrl"
    :data-gp-mapp-seq="gpMappSeq"
    :data-ads-dtl-seq="adsDtlSeq"
    :data-ads-seq="adsSeq"
    :data-pay-yn="payYn"
    :data-comp-nm="compNm"
  >
    <!-- 추천형 -->
    <!--    <section-->
    <!--      class="ep-banner-item"-->
    <!--      style="background-image: url('https://pgnqdrjultom1827145.cdn.ntruss.com/img/7f/dc/7fdcb2cc45be8b0b56ffcd94e0b99884162d5898775eb76fe70eaa2734e280f2_v1.jpg')"-->
    <!--      v-if="html"-->
    <!--    >-->
    <!--      <div class="ep-banner-item-body">-->
    <!--        <h1 class="ep-banner-item-title">-->
    <!--          <strong>30대 <span>여성</span></strong-->
    <!--          >들이<br />가장 많이 선택한-->
    <!--        </h1>-->
    <!--      </div>-->
    <!--      <div class="ep-banner-item-footer">-->
    <!--        <figure>-->
    <!--          <span class="ep-banner-item-img-wrap"><img src="http://172.30.1.157:1004/202103/2021031518033075.png" alt="" /></span>-->
    <!--          <figcaption><em>KB 국민 탄탄대로 올쇼핑</em><span>제휴지원금 10만원</span></figcaption>-->
    <!--        </figure>-->
    <!--      </div>-->
    <!--    </section>-->
    <!-- // 추천형 -->

    <!-- 기본형 -->
    <!--    <section-->
    <!--      class="ep-banner-item"-->
    <!--      style="background-image: url('https://pgnqdrjultom1827145.cdn.ntruss.com/img/7f/dc/7fdcb2cc45be8b0b56ffcd94e0b99884162d5898775eb76fe70eaa2734e280f2_v1.jpg')"-->
    <!--      v-if="html"-->
    <!--    >-->
    <!--      <div class="ep-banner-item-body">-->
    <!--        <h1 class="ep-banner-item-title">-->
    <!--          신한카드<br />-->
    <!--          <strong>10만원 지원금</strong>-->
    <!--        </h1>-->
    <!--        <button type="button" class="ep-banner-item-btn-detail">자세히 보기</button>-->
    <!--      </div>-->
    <!--    </section>-->
    <!-- //기본형 -->

    <section class="ep-banner-item" v-if="html">
      <div class="ep-banner-item-media" v-html="html" role="button"></div>
    </section>

    <section class="ep-banner-item" v-if="imgPath">
      <div class="ep-banner-item-media"><img :src="imgPath" :alt="`${bannerName} 배너 이미지`" role="button" /></div>
    </section>
  </div>
</template>

<script>
export default /*#__PURE__*/ {
  name: "EpBannerItem",
  props: {
    isPreview: {
      type: Boolean,
      default: false
    },
    destinationType: {
      type: String,
      default: "D"
    },
    destinationUrl: {
      type: String,
      default: ""
    },
    imgPath: {
      type: String,
      default: ""
    },
    seq: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    compNm: {
      type: String,
      default: ""
    },
    promotionSeq: {
      type: String,
      default: ""
    },
    itSeq: {
      type: String,
      default: ""
    },
    html: {
      type: String,
      default: ""
    },
    gpMappSeq: {
      type: Number,
      default: null
    },
    adsDtlSeq: {
      type: Number,
      default: null
    },
    adsSeq: {
      type: Number,
      default: null
    },
    payYn: {
      type: String,
      default: "N"
    }
  },

  computed: {
    bannerName() {
      if (this.name && this.name !== "") {
        return this.name;
      } else {
        return this.compNm;
      }
    }
  }
};
</script>

<style lang="scss">
.ep-banner-item {
  $g-preview: &;
  display: flex;
  flex-direction: column;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: cover;

  &:before {
    content: "";
    width: 1px;
    margin-left: -1px;
    float: left;
    height: 0;
    padding-top: 220px / 390px * 100%;
  }

  &-media {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    video {
      width: 100%;
      height: 100%;
    }

    iframe {
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  &-body {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    padding: vw(39px) vw(33px) vw(23px);

    @at-root {
      .preview {
        #{$g-preview}-body {
          padding: rem(39px) rem(33px) rem(23px);
        }
      }
    }
  }

  &-img-wrap {
    display: inline-block;
    width: vw(55px);
    height: vw(34px);
    background: #ddd;
    filter: drop-shadow(0px 12px 16px rgba(0, 0, 0, 0.13));

    @at-root {
      .preview {
        #{$g-preview}-img-wrap {
          width: rem(55px);
          height: rem(34px);
        }
      }
    }

    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }

  &-footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0 vw(34px);

    @at-root {
      .preview {
        #{$g-preview}-footer {
          padding: 0 rem(34px);
        }
      }
    }

    figure {
      margin: 0 0 0 2px;
      display: flex;
      align-items: center;
      padding: vw(23px) 0;
      border-top: 1px solid rgba(34, 34, 34, 0.15);

      @at-root {
        .preview {
          figure {
            padding: rem(23px) 0;
          }
        }
      }

      figcaption {
        display: flex;
        flex-direction: column;
        margin-left: vw(18px);
        font-size: vw(13px);
        letter-spacing: -0.2px;
        line-height: (18/13);

        em {
          font-style: normal;
          font-weight: 500;
          font-size: vw(15px);
          line-height: (24/15);
        }

        @at-root {
          .preview {
            figcaption {
              margin-left: rem(18px);
              font-size: rem(13px);

              em {
                font-size: rem(15px);
              }
            }
          }
        }
      }
    }
  }

  &-title {
    margin: 0;
    font-size: vw(26px);
    font-weight: 400;
    line-height: (35/26);
    letter-spacing: -0.5px;
    color: $color-grey-6;

    @at-root {
      .preview {
        #{$g-preview}-title {
          font-size: rem(26px);
        }
      }
    }

    strong {
      font-weight: 700;
    }
  }

  &-btn-detail {
    display: inline-block;
    height: vw(42px);
    margin: vw(23px) 0 0;
    padding: vw(10px);
    -webkit-appearance: none;
    background: #fff;
    border: none;
    border-radius: vw(4px);
    font-size: vw(14px);
    line-height: (20/14);
    text-decoration: none;
    letter-spacing: -0.2px;
    color: $color-grey-6;
    box-sizing: border-box;

    @at-root {
      .preview {
        #{$g-preview}-btn-detail {
          height: rem(42px);
          margin: rem(23px) 0 0;
          padding: rem(10px);
          font-size: rem(14px);
          border-radius: rem(4px);
        }
      }
    }
  }
}
</style>
